/** Short relative time for comment threads — Asia/Manila wall clock elsewhere. */
export function relativeTimeLabel(
  iso: string,
  nowMs = Date.now(),
): string {
  const t = new Date(iso).getTime();
  if (!Number.isFinite(t)) return "";
  const diffSec = Math.round((nowMs - t) / 1000);
  if (diffSec < 45) return "just now";
  if (diffSec < 3600) return `${Math.max(1, Math.round(diffSec / 60))}m`;
  if (diffSec < 86400) return `${Math.max(1, Math.round(diffSec / 3600))}h`;
  if (diffSec < 86400 * 7) return `${Math.max(1, Math.round(diffSec / 86400))}d`;
  return new Date(iso).toLocaleDateString("en-PH", {
    timeZone: "Asia/Manila",
    month: "short",
    day: "numeric",
  });
}

/** Normalize API date wire (YYYY-MM-DD or ISO) to calendar YYYY-MM-DD. */
export function asCalendarYmd(raw: string | null | undefined): string {
  if (!raw) return "";
  return String(raw).trim().slice(0, 10);
}

/** Absolute short label for a calendar docDate — plan/35. */
export function formatDocDateLabel(raw: string | null | undefined): string {
  const ymd = asCalendarYmd(raw);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return raw?.trim() || "—";
  return new Date(`${ymd}T12:00:00Z`).toLocaleDateString("en-PH", {
    timeZone: "UTC",
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

/** Relative age of a calendar docDate (start of day, Asia/Manila). */
export function docDateRelativeLabel(
  raw: string | null | undefined,
  nowMs = Date.now(),
): string {
  const ymd = asCalendarYmd(raw);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) return "";
  return relativeTimeLabel(`${ymd}T00:00:00+08:00`, nowMs);
}
